import { Box, Text, useColorModeValue } from '@chakra-ui/react';

const AI_RESPONSE_FONT =
  'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

export function AiLeagueJustification(props: { text: string }) {
  const color = useColorModeValue('gray.800', 'gray.100');

  return (
    <Box w='full' textAlign='left'>
      <Text
        fontFamily={AI_RESPONSE_FONT}
        fontSize='sm'
        lineHeight='tall'
        color={color}
        whiteSpace='pre-wrap'
        textAlign='left'
      >
        {props.text}
      </Text>
    </Box>
  );
}
